var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgStoreOperationsReporting = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 152.000000 152.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Color-/-FOH",
    fill: "#000000",
    x: 0,
    y: 0,
    width: 200,
    height: 200
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.000000,11.000000) scale(5.5,5.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    stroke: "#FFFFFF",
    d: "M16.5 21.75h-9c-1.242 0-2.25-1.191-2.25-2.66V4.91c0-1.469 1.008-2.66 2.25-2.66h6.75l4.5 4.5v12.34c0 1.469-1.008 2.66-2.25 2.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    d: "M18.75 6.75H15.5a1.5 1.5 0 01-1.5-1.5V2m2.25 10.5l-3 3-1.5-1.5L8 17.75"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStoreOperationsReporting);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/storeOperationsReporting.0263cdc7042cc9b006a2536080efe977.svg";